import { NotificationConfig, NotificationType } from '@routific/hive';
import upperFirst from 'lodash/upperFirst';

export const routeAddSuccessNotification = (routeId?: string, routeName?: string): NotificationConfig => ({
  type: NotificationType.INFO,
  id: routeId as string,
  message: `Route added (${routeName})`,
});

export const routeAddFailNotification = (routeId?: string, routeName?: string): NotificationConfig => ({
  type: NotificationType.INFO,
  id: routeId as string,
  message: `Unable to load route ${routeName}`,
});

export const routeDeletedNotification = (routeId?: string, routeName?: string): NotificationConfig => ({
  type: NotificationType.INFO,
  id: routeId as string,
  message: `Route deleted (${routeName})`,
});

export const routeUpdatedNotification = (routeId?: string, routeName?: string, onClick?: () => void): NotificationConfig => ({
  type: NotificationType.SUCCESS,
  id: `${routeId}-success`,
  message: upperFirst(`${routeName} updated successfully`),
  linkOnClick: onClick,
  linkMessage: 'View Route',
  dataCy: 'update-route-success-notification',
});

export const routeUpdateFailedNotification = (routeId?: string, routeName?: string): NotificationConfig => ({
  type: NotificationType.ERROR,
  id: `${routeId}-error`,
  message: `Sorry, something went wrong and couldn't update ${routeName}`,
  dataCy: 'update-route-error-notification',
});
